import React from 'react';
import { Routes, Route } from 'react-router-dom'; // Apenas Routes e Route aqui
import Menu from './Componentes/Menu/Menu';
import './App.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import SessaoPrincipal from './Componentes/SessaoPrincipal/SessaoPrincipal';
import Sobre from './Componentes/Sobre/Sobre';
import Numeros from './Componentes/Numeros/Numeros';
import Servicos from './Componentes/Servicos/Servicos';
import Clientes from './Componentes/Clientes/Clientes';
import Informacoes from './Componentes/Informacoes/Informacoes';
import Rodape from './Componentes/Rodape/Rodape';

function App() {
  return (
    <>
      {/* Menu fixo no topo */}
      <Menu />

      {/* Definindo as rotas */}
      <Routes>
        {/* Página inicial */}
        <Route
          path="/"
          element={
            <>
            <SessaoPrincipal />
            <Sobre />
            <Numeros/>
            <Servicos />
            <Clientes />
            <Informacoes />
            </>
          }
        />
        
        {/* Página da unidade específica */}
        {/* <Route path="/unidade-centro" element={<UnidadeCentro />} /> */}
      </Routes>

      {/* Rodapé fixo no final */}
      <Rodape />

      {/* Importando o CSS global */}
    </>
  );
}

export default App;

